import styled from 'styled-components';
import theme from 'styles/theme';

export const LoadingSpinner = styled.div<{
  $backgroundColor?: string;
  $color?: string;
  $size?: string;
}>`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  animation: spin 1s linear infinite;
  border-bottom-color: ${({ $backgroundColor }) =>
    $backgroundColor ?? 'transparent'};
  border-left-color: ${({ $color }) => $color ?? theme.colors.hostfullyYellow};
  border-radius: 50%;
  border-right-color: ${({ $color }) => $color ?? theme.colors.hostfullyYellow};
  border-style: solid;
  border-top-color: ${({ $color }) => $color ?? theme.colors.hostfullyYellow};
  border-width: 3px;
  display: inline-block;
  height: ${({ $size }) => $size ?? '16px'};
  width: ${({ $size }) => $size ?? '16px'};
`;
